import { CommonModule } from '@angular/common';
import {Component, Input } from '@angular/core';

@Component({
    selector: 'label-item',
    template: `
    <div class="label_item" [ngStyle]="{background: color}">{{label}}</div>
`,
    styleUrls: ['./label-item.component.scss'],
    standalone: true,
    imports: [CommonModule],
})

export class LabelItemComponent  {
  loading = true;
  panelWidth = 480;
  offsetX = 200;
  @Input() color = '';
  @Input() label?:string;
  constructor() {

  }
}

